<template>
  <div class="modal-wrapper" @click.self="$emit('close')">
    <div class="investment-modal">
      <div class="sidebar">
        <div class="sidebar-header">
          <div class="title">Nueva inversión</div>
        </div>
        <div class="investment-summary">
          <div class="summary-item">
            Nombre del proyecto
            <div class="value">{{ currentProject.name }}</div>
          </div>
          <div class="summary-item">
            Ubicación del proyecto
            <div class="value">{{ currentProject.location }}</div>
          </div>
          <div class="summary-item" v-show="currentStep > 2">
            Nombre completo
            <div class="value">{{ user.name + ' ' + user.lastName }}</div>
          </div>
          <div class="summary-item" v-show="currentStep > 4">
            Forma de pago
            <div class="value">{{ paymentMethod === 'card' ? 'Tarjeta' : 'Transferencia interbancaria' }}</div>
          </div>
          <div class="summary-item-investment" v-show="currentStep > 3">
            Datos de la Inversión
            <div class="investment-table">
              <div class="table-row">
                <div class="table-title">
                  Inversión
                </div>
                <div class="table-value">
                  ${{ stylizeNumber(totalInvestment.toFixed(2)) }}
                </div>
              </div>
              <div class="table-row">
                <div class="table-title">
                  Comisión bancaria
                </div>
                <div class="table-value" v-if="comissions">
                  ${{ stylizeNumber((comissions - totalInvestment).toFixed(2)) }}
                </div>
              </div>
              <!-- <div class="table-row">
                <div class="table-title">
                  IVA
                </div>
                <div class="table-value" v-if="comissions">
                  ${{ stylizeNumber(((comissions) * 0.16).toFixed(2)) }}
                </div>
              </div> -->
              <div class="table-total">
                <div>Total de inversión</div>
                <div>${{ stylizeNumber(totalInvestment.toFixed(2)) }}</div>
              </div>
              <div class="table-total" v-if="comissions">
                <div>Total a pagar</div>
                <div>${{ stylizeNumber(comissions.toFixed(2)) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main">
        <steps :items="menuItems" v-model="currentStep"/>
        <div class="section-wrapper">
          <component :is="`Section${currentStep + 1}`" @next="currentStep += 1"></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Steps from '@/components/Steps.vue';
import Section1 from '@/components/investment/1.vue';
import Section2 from '@/components/investment/Invest.vue';
// import Section2 from '@/components/investment/2.vue';
import Section3 from '@/components/investment/3.vue';
import Section4 from '@/components/investment/4.vue';
import Section5 from '@/components/investment/5.vue';
import Section6 from '@/components/investment/6.vue';
import Section7 from '@/components/investment/7.vue';

const { mapState } = createNamespacedHelpers('investment');

export default {
  data() {
    return {
      currentStep: 0,
      menuItems: ['Inversión', 'Listo'],
      // menuItems: ['Inversión', 'Inversionista', 'Datos', 'Forma de pago', 'Info del pago', 'Contrato y cargo'],
    };
  },
  components: {
    Section1,
    Section2,
    Section3,
    Section4,
    Section5,
    Section6,
    Section7,
    Steps,
  },
  methods: {
    stylizeNumber(number) {
      if (number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
      return null;
    },
  },
  computed: {
    comissions() {
      if (this.paymentMethod) {
        switch (this.paymentMethod) {
          case 'card':
            return (this.totalInvestment + 2.95) / 0.96636;
          case 'spei':
            return this.totalInvestment * 0.01;
          default:
            break;
        }
      }
      return null;
    },
    user() {
      return this.$store.state.user.user;
    },
    ...mapState([
      'currentProject',
      'paymentMethod',
      'totalInvestment',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.modal-wrapper {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  padding-top: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.438);
}
.investment-modal {
  display: flex;
  width: 80%;
  height: 90%;
  border-radius: 12px;
}
.sidebar {
  width: 30%;
  background-color: #f6f6f6;
  border-radius: 12px 0 0 12px;
  padding: 24px;
}
.main {
  width: 70%;
  background-color: white;
  border-radius: 0 12px 12px 0;
}
.sidebar-header {
  border-top-left-radius: 12px;
  font-family: "Inter", sans-serif;
  margin-bottom: 30px;
}
.title {
  font-size: 28px;
  margin-bottom: 8px;
  font-weight: bolder;
}
.subtitle {
  font-weight: bolder;
  font-size: 16px;
  letter-spacing: 0.15px;
}
.main {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.section-wrapper {
  width: 90%;
  // width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  flex-grow: 1;
}
/deep/ .section-title {
  font-size: 24px;
  margin-bottom: 10px;
  color: #202124;
  font-weight: bolder;
}
/deep/ .section-content {
  display: flex;
  justify-content: space-between;
  line-height: 20px;
}
/deep/ .section-summary {
  font-size: 15px;
  margin-bottom: 16px;
  font-family: "Inter", sans-serif;
  color: #5f6368;
  line-height: 1.2;
}
/deep/ .section-column {
  width: 48%;
  display: flex;
  flex-direction: column;
}
/deep/ .input-label {
  font-size: 16px;
  margin: 14px 0;
}
/deep/ .input {
  width: 100%;
  margin-top: 8px;
  font-size: 14px;
  font-weight: 400;
  padding: 10px 12px;
  border: none;
  border: 1px solid #e0e3e8;
  border-radius: 6px;
}
/deep/ .dropdown-toggle {
  margin-top: 8px;
  font-size: 14px !important;
  font-weight: 400 !important;
  height: 39px;
  border: 1px solid #e0e3e8 !important;
  border-radius: 6px !important;
}
/deep/ .section-button {
  display: flex;
  justify-content: flex-end;
  min-height: 56px;
}
/deep/ .button {
  font-size: 14px;
  padding: 12px 30px;
  text-align: center;
  background-color: #2c70c1;
  margin-top: 16px;
  color: white;
  cursor: pointer;
}

.number {
  margin-right: 10px;
  border-radius: 50%;
  color: white;
  background-color: #e0e3e8;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  margin-bottom: 14px;
}
.current-step {
  color: #2c70c1;
  .number {
    background-color: #2c70c1;
  }
}
.finished-step {
  color: #7fbe3b;
  .number {
    background-color: #7fbe3b;
  }
}
.summary-item {
  font-size: 16px;
  font-weight: 500;
  margin: 15px 0;

  .value {
    font-weight: 400;
    margin-top: 6px;
  }
}
.table-total {
  width: 100%;
  display: flex;
  justify-content: space-between;
  background-color: #f6f6f6;
  padding: 16px 22px;
  border-radius: 6px;
  margin: 10px 0 0 0;

  & + .table-total {
    margin-top: 16px;
  }
}

@media only screen and (max-width: 1200px) {
  .investment-modal {
    width: 94%;
  }
}
@media only screen and (max-width: 900px) {
  .sidebar {
    display: none;
  }
  .main {
    width: 100%;
  }
}
@media only screen and (max-width: 640px) {
  .modal-wrapper {
    padding-bottom: 100px;
  }
  .investment-modal {
    -webkit-overflow-scrolling: touch;
    overflow-y: scroll;
  }
  .main {
    height: fit-content;
    padding-bottom: 20px;
  }
  /deep/ .section-content {
    flex-direction: column;
  }
  /deep/ .section-column {
    width: 90%;
  }
}
.investment-table {
  margin-top: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 20px 12px;
  border-radius: 5px;
}
.table-row {
  width: 100%;
  margin-bottom: 12px;
  display: flex;
}
.table-title {
  width: 70%;
  font-weight: 500;
}
.table-value {
  width: 30%;
  font-weight: 400;
}
.summary-item-investment {
  font-size: 16px;
  font-weight: 500;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: -12px;
  margin-right: -12px;

  .value {
    font-weight: 400;
    margin-top: 6px;
  }
}
</style>

